// MapLayerComponent.jsx
import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import Divider from '@mui/material/Divider';
import StormDateDropDown from '../StormDateDropDown';

const MapLayerComponent = ({ layersVisible, colorScheme, handleColorSchemeChange }) => {
    return (
        layersVisible && (
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 60,
                    zIndex: 10,
                    borderRadius: '5px',
                    padding: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <FormControl
                    variant="standard"
                    sx={{
                    position: 'absolute',
                    top: 15,
                    left: 15,
                    zIndex: 1000,
                    width: 'auto',
                    // backgroundColor: '#212121',
                    }}
                >
                    <InputLabel id="color-scheme-label">Map Layer</InputLabel>
                    <Select
                    labelId="color-scheme-label"
                    value={colorScheme}
                    onChange={handleColorSchemeChange}
                    label="Color Subcatchments"
                    >
                    <MenuItem value="standard">None</MenuItem>
                    <Divider />
                    <MenuItem value="percent_impervious">Percent Impervious</MenuItem>
                    <MenuItem value="elevation">Elevation</MenuItem>
                    <MenuItem value="soil_type">Soil Type</MenuItem>
                    <Divider />
                    <MenuItem value="drawdown">Estimated Drainage</MenuItem>
                    </Select>
                </FormControl>
                <div style={{ marginTop: '70px', marginLeft: '-10px' }}>
                    <StormDateDropDown />
                </div>
            </div>
        )
    );
};

export default MapLayerComponent;
